import { Injectable, Injector } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from 'src/environments/environment';
import { APP_VERSION } from 'src/environments/version';
import { UserSite } from '../auth/auth.models';
import { ILogger, LoggerService } from '../logging';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  private logger: ILogger;

  private userId: number | null = null;
  private userSite: UserSite | undefined = undefined;

  private isActive = environment.googleTagManager.isActive;
  constructor(
    private gtmService: GoogleTagManagerService,
    injector: Injector,
  ) {
    this.logger = injector.get(LoggerService).getLogger('GoogleAnalyticsService');
  }

  async init() {
    if (this.isActive) {
      await this.gtmService.addGtmToDom();
      this.logger.debug('GTM loaded');
    }
  }

  setUserId(userId: number | null) {
    this.logger.debug('setUserId:' + userId);
    this.userId = userId;
  }

  setUserSite(userSite: UserSite | undefined) {
    this.logger.debug('setUserSite:' + userSite?.name);
    this.userSite = userSite;
  }

  /** Track page View if enabled by config */
  async trackPageView(pagePath: string, pageTitle: string | undefined) {
    if (!this.isActive) return;

    // When we don't have title we use path to make it visible in Google Analytics to fix it
    if (!pageTitle) {
      pageTitle = pagePath;
      this.logger.error(`PageView - empty title for : ${pagePath}`);
    }

    const gtmTag = {
      event: 'PageView',
      page_path: pagePath,
      page_title: pageTitle,
      user_id: this.userId,
      user_site_cdpf: this.userSite?.cdpf,
      user_site_name: this.userSite?.name,
      user_site_brand: this.userSite?.marqueName,
      app_version: APP_VERSION,
    };

    // Commented to avoid polluting logs, uncomment if debug is needed
    //this.logger.debug('gtmTag:' + JSON.stringify(gtmTag));

    await this.gtmService.pushTag(gtmTag);
  }
}
